<script setup lang="ts">
import { cn } from '../lib/utils';
const props = defineProps<{
  class?: string
  style?: any
}>()
</script>

<template>
  <div :class="cn('w-full h-0 rounded-sm border-b-2 border-slate-200', props.class)" :style="props.style"></div>
</template>
